import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const ForcePasswordChangePage = Loadable(lazy(() => import('pages/auth/ForcePasswordChange')));
const TwoFactorPage = Loadable(lazy(() => import('pages/auth/TwoFactor')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/change-password',
          element: <ForcePasswordChangePage />
        },
        {
          path: '/two-factor',
          element: <TwoFactorPage />
        }
      ]
    }
  ]
};

export default LoginRoutes;
